import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import EscalationProfileDetails from 'containers/EscalationProfileDetails';
import UserRoute from 'components/Route/UserRoute';
import routes from 'core/routes';

import { useStore } from 'utils/hooks/store';
import { SessionStoreWithUser } from 'stores/Session/types';

import { ADMIN_AND_MANAGERS, NON_ARC_OPERATORS } from 'utils/roles/roleGroups';

import EscalationProfiles from '../EscalationProfiles';

const Routing = (): React.ReactElement => {
  const { session: sessionRaw } = useStore();
  const session = sessionRaw as SessionStoreWithUser;

  return (
    <Routes>
      <Route
        path=""
        element={
          <UserRoute
            isAuthorizedUser={(user) => NON_ARC_OPERATORS.includes(user.role) && session.user.licenses.protectorAlarms}
          >
            <EscalationProfiles />
          </UserRoute>
        }
      />

      <Route
        path=":escalationProfileId"
        element={
          <UserRoute
            isAuthorizedUser={(user) => ADMIN_AND_MANAGERS.includes(user.role) && session.user.licenses.protectorAlarms}
          >
            <EscalationProfileDetails />
          </UserRoute>
        }
      />

      <Route path="*" element={<Navigate to={String(routes.dashboard.alarms.escalationProfiles)} replace />} />
    </Routes>
  );
};

export default Routing;
